import script from "./LingoStudentVocabularyKC.vue?vue&type=script&setup=true&lang=ts"
export * from "./LingoStudentVocabularyKC.vue?vue&type=script&setup=true&lang=ts"

import "./LingoStudentVocabularyKC.vue?vue&type=style&index=0&id=a788eb58&lang=scss&scoped=true"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a788eb58"]])

export default __exports__